<template>
  <div class="col-12">
    <div class="text-center" v-if="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <b-card v-else>
      <div slot="header">{{ $lang.faq }}</div>
      <div class="accordion" role="tablist">
        <b-card
          v-for="(item, index) in items"
          :key="index"
          no-body
          class="mb-1"
        >
          <b-card-header
            v-if="item.is_enable == 1"
            header-tag="header"
            class="p-0"
            role="tab"
            v-b-toggle="`collapse-${index}`"
          >
            <b-button
              block
              variant="info"
              class="
                d-flex
                align-items-center
                justify-content-between
                py-3
                text-white
              "
            >
              <div class="text-left" v-text="item.question" />
              <i class="fas fa-chevron-down" />
            </b-button>
          </b-card-header>
          <b-collapse :id="`collapse-${index}`" accordion="my-accordion">
            <b-card-body class="card-body-text">
              <b-card-text>{{ item.answer }}</b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  inject: ["faqRepository"],
  data() {
    return {
      isLoading: false,
      items: [],
    };
  },
  methods: {
    async fetchData() {
      try {
        this.isLoading = true;
        const response = await this.faqRepository.list();
        this.items = response.data.data;
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  async created() {
    await this.fetchData();
  },
};
</script>

<style>
.card-body-text {
  border: 1px solid lightgray;
}
</style>
